import React from "react";
import IMAGES from "@/public/assets/img";
import Image from "next/image";

const creditComparison = {
  title: "Credlix <br/> VS. <br/> Traditional",
  subtitle: "Credit Checks",
  traditional: {
    title: "Traditional Checks",
    points: [
      "Lengthy Approvals",
      "Time-consuming Process",
      "High Costs",
      "Limited Data",
    ],
  },
  credlix: {
    title: "Credlix",
    points: [
      "Instant Reports",
      "Saves time & resources",
      "Cost-effective",
      "Comprehensive data",
    ],
  },
};

const { title, subtitle, traditional, credlix } = creditComparison;

const renderPoints = (points) => (
  <ul>
    {points.map((point, idx) => (
      <li key={idx} className="flex items-center gap-2 text-gray-700 mb-2">
        <Image
          src={IMAGES.termsheet.check}
          alt="Check"
          width={24}
          height={24}
        />
        <span>{point}</span>
      </li>
    ))}
  </ul>
);
const CreditCheck = () => {
  return (
    <section className="py-[100px] sm:pt-0">
      <div className="container xm:px-2 px-3 max-w-[1200px]">
        <div className="flex justify-center items-center sm:flex-col">
          
          <div className="border border-[#C4C4C4] rounded-2xl p-6 sm:w-full w-1/3  mr-[-20px] sm:mr-0">
            <h3 className="text-xxl font-bold mb-4">{traditional.title}</h3>
            <ul>{renderPoints(traditional.points)}</ul>
          </div>

          <div className="bg-[#072F5F] text-white text-center px-8 py-14 rounded-2xl sm:w-full w-1/3 shadow-md relative sm:mt-[-20px]">
            <h2
              className="text-[36px] leading-[67px] font-medium mb-2"
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <p className="text-heading2 font-medium">{subtitle}</p>
          </div>

          <div className="border border-[#C4C4C4] rounded-2xl p-6 sm:w-full lw-1/3 ml-[-15px] bg-white sm:ml-0 sm:mt-[-20px]">
            <h3 className="text-xl font-semibold mb-4">{credlix.title}</h3>
            <ul>{renderPoints(credlix.points)}</ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CreditCheck;
